/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".number-column[_ngcontent-%COMP%]{text-align:right}.action-button[_ngcontent-%COMP%]{margin-left:5px}"];
export { styles as styles };
